import React from 'react';

const PropertyFeed = ({ items, onNewTransaction, onNewBooking, onEditBooking, onDeleteBooking, defaultCleaningFee }) => {
    const formatCurrency = (value) => '$' + new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value) || 0);
    const formatDate = (value) => {
        if (!value) return '-';
        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return '-';
        return parsed.toLocaleDateString();
    };

    const getBookingMetrics = (booking) => {
        const amount = Number(booking.amount) || 0;
        const start = booking.startDate ? new Date(booking.startDate) : null;
        const end = booking.endDate ? new Date(booking.endDate) : null;

        if (!start || !end || Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
            return { costPerNight: null, nights: null };
        }

        const rawNights = Math.round((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24));
        const nights = Math.max(1, rawNights);
        return { costPerNight: amount / nights, nights };
    };

    return (
        <section className="profile-card">
            <div className="property-feed-header">
                <div>
                    <h3>Property Feed</h3>
                    <p className="property-feed-subtitle">Latest bookings and transactions for this property.</p>
                </div>
                <div className="property-feed-actions">
                    <button type="button" className="btn-primary" onClick={onNewTransaction}>New Transaction</button>
                    <button type="button" className="btn-primary" onClick={onNewBooking}>New Booking</button>
                </div>
            </div>

            {items.length === 0 ? (
                <p className="no-features">No bookings or transactions recorded for this property yet.</p>
            ) : (
                <ul className="property-feed-list">
                    {items.map((item) => {
                        if (item.type === 'booking') {
                            const { costPerNight, nights } = getBookingMetrics(item);
                            return (
                                <li key={`booking-${item.id}`} className="property-feed-item property-feed-booking">
                                    <div className="property-feed-topline">
                                        <span className="property-feed-badge revenue">Booking</span>
                                        <strong className="net-positive">{formatCurrency(item.amount)}</strong>
                                    </div>
                                    <p>{item.description || 'No booking description'}</p>
                                    <div className="property-feed-meta">
                                        <span>Source: {item.source || '—'}</span>
                                        <span>Check-in: {formatDate(item.startDate)}</span>
                                        <span>Check-out: {formatDate(item.endDate)}</span>
                                        <span>Nights: {nights === null ? '-' : nights}</span>
                                        <span>Per night: {costPerNight === null ? '-' : formatCurrency(costPerNight)}</span>
                                        <span>
                                            Cleaning fee: {formatCurrency(item.cleaningFee !== undefined && item.cleaningFee !== null ? item.cleaningFee : defaultCleaningFee)}
                                            {(item.cleaningFee === undefined || item.cleaningFee === null) ? ' (default)' : ' (custom)'}
                                        </span>
                                    </div>
                                    <div className="item-actions" style={{ marginTop: '10px' }}>
                                        <button type="button" className="btn-secondary btn-inline" onClick={() => onEditBooking(item)}>Edit</button>
                                        <button type="button" className="btn-secondary btn-inline btn-danger-inline" onClick={() => onDeleteBooking(item)}>Delete</button>
                                    </div>
                                </li>
                            );
                        }

                        return (
                            <li key={`transaction-${item.id}`} className="property-feed-item property-feed-transaction">
                                <div className="property-feed-topline">
                                    <span className="property-feed-badge expense">Transaction</span>
                                    <strong className="net-negative">-{formatCurrency(item.amount)}</strong>
                                </div>
                                <p>{item.description || 'No transaction description'}</p>
                                <div className="property-feed-meta">
                                    <span>Date: {formatDate(item.date)}</span>
                                    <span>Category: {item.category || 'Uncategorized'}</span>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
};

export default PropertyFeed;